import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const roleGuard =
  (allowedRoles: ('admin' | 'superadmin' | 'backoffice' | 'profesional' | 'paciente' | 'administrative')[]): CanActivateFn =>
  () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (!auth.isLoggedIn()) {
      router.navigate(['/login']);
      return false;
    }

    if (!auth.hasRole(allowedRoles)) {
      router.navigate(['/']);
      return false;
    }

    return true;
  };
